/**
 * @generated SignedSource<<0757487f75acbfda695510038025c727>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type introduceEditorTemplateSelectorQuery$variables = Record<PropertyKey, never>;
export type introduceEditorTemplateSelectorQuery$data = {
  readonly grapes_template_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly contenthtml: string;
        readonly description: string;
        readonly id: string;
        readonly imageurl: string;
        readonly name: string;
      };
    }>;
  };
};
export type introduceEditorTemplateSelectorQuery = {
  response: introduceEditorTemplateSelectorQuery$data;
  variables: introduceEditorTemplateSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "grapes_templateConnection",
    "kind": "LinkedField",
    "name": "grapes_template_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "grapes_templateEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "grapes_template",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contenthtml",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageurl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "introduceEditorTemplateSelectorQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "introduceEditorTemplateSelectorQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "245807835880d0123324af6760f3f29b",
    "id": null,
    "metadata": {},
    "name": "introduceEditorTemplateSelectorQuery",
    "operationKind": "query",
    "text": "query introduceEditorTemplateSelectorQuery {\n  grapes_template_connection {\n    edges {\n      node {\n        id\n        contenthtml\n        description\n        imageurl\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b8c1fcb45adba23a0ee6ef5e8ef5af3c";

export default node;
